var _defs, _circle, _circle2, _path, _line, _path2, _path3, _path4, _path5, _circle3, _circle4, _line2, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7aece;}.cls-2,.cls-3{fill:#515570;}.cls-2{opacity:0.2;}.cls-10,.cls-11,.cls-4,.cls-7,.cls-8{fill:none;stroke-linecap:round;}.cls-4,.cls-8{stroke:#fbc0aa;}.cls-10,.cls-4,.cls-8{stroke-linejoin:round;}.cls-4{stroke-width:14px;}.cls-5{fill:#393c54;}.cls-6{fill:#ffd8c9;}.cls-11,.cls-7{stroke:#ffffff;stroke-miterlimit:10;}.cls-7{stroke-width:4px;opacity:0.1;}.cls-8{stroke-width:5px;}.cls-9{fill:#f85565;opacity:0.5;}.cls-10{stroke:#f85565;}.cls-10,.cls-11{stroke-width:2px;}.cls-11{opacity:0.7;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64,124a59.67,59.67,0,0,0,34.69-11.06l-3.32-9.3A10,10,0,0,0,86,97H42.05a10,10,0,0,0-9.42,6.64l-3.32,9.3A59.67,59.67,0,0,0,64,124Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64,
    x2: 64,
    y1: 84.75,
    y2: 98.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,124a59.77,59.77,0,0,0,41.6-16.79c-2.28-7.34-7.31-21-7.31-24.28V48.32A34.32,34.32,0,0,0,64,14h0A34.31,34.31,0,0,0,29.65,48.32V82.93c0,3.39-4.62,17.82-6.54,25A59.78,59.78,0,0,0,64,124Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64,91A25,25,0,0,1,39,66V49.52a25,25,0,1,1,50,0V66A25,25,0,0,1,64,91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.67,49.19a28.33,28.33,0,0,1,56.66,0L92,51.48,36,51.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.22,38.85A21.67,21.67,0,0,1,63.35,25.34"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76,
    cy: 58.28,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 52,
    cy: 58.28,
    r: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 64,
    x2: 64,
    y1: 63.75,
    y2: 68.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M69.15,78.94c0,2-2.3,3.16-5.15,3.16s-5.15-1.52-5.15-3.16c0-2.84,2.48-3.94,5.15-3.15C66.58,74.92,69.15,76.1,69.15,78.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M58,77.87a16.83,16.83,0,0,0,12,0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.42,48.48a118.24,118.24,0,0,0-44.84,0A3.21,3.21,0,0,0,39,51.64V55a105.67,105.67,0,0,1,50,0V51.64A3.21,3.21,0,0,0,86.42,48.48Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.36,65.68a28.34,28.34,0,1,1-56.67,0s19.19-1.29,26.16-3.83a6.23,6.23,0,0,1,4.3,0C73.13,64.39,92.36,65.68,92.36,65.68Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M35.69,116.89l0-67.7a28.33,28.33,0,0,1,56.66,0l0,67.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotAvatar);
export default __webpack_public_path__ + "static/media/botAvatar.bf70853f8bb7d3fadef272164dbd7e99.svg";
export { ForwardRef as ReactComponent };